import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export type AdminV2IconName =
  | "search"
  | "chevron-down"
  | "check"
  | "checkmark-circle"
  | "check-circle-filled"
  | "close"
  | "kyc-status"
  | "toggle"
  | "layers"
  | "filter"
  | "filter-horizontal"
  | "plus"
  | "wallet"
  | "gift"
  | "money-bag"
  | "invoice"
  | "user-circle"
  | "user-multiple"
  | "user-settings"
  | "chart-line"
  | "transfer"
  | "exchange"
  | "bank"
  | "unfold-more"
  | "help-circle"
  | "arrow-right"
  | "arrow-left"
  | "home"
  | "notification"
  | "grid"
  | "money-add"
  | "money-send"
  | "wallet-add"
  | "pause"
  | "cancel-circle"
  | "credit-card"
  | "restaurant"
  | "fuel-station"
  | "airplane"
  | "wifi"
  | "wallet-01"
  | "wallet-02"
  | "refresh"
  | "qr-code"
  | "information-circle"
  | "lock"
  | "unlock"
  | "building"
  | "arrow-down-left"
  | "arrow-up-right"
  | "arrow-circle-down"
  | "download"
  | "loading-03"
  | "clock"
  | "alert"
  | "warning"
  | "error"
  | "copy"
  | "edit"
  | "eye"
  | "time"
  | "zoom-in"
  | "zoom-out"
  | "expand"
  | "file"
  | "clipboard"
  | "link"
  | "receipt"
  | "shield"
  | "message"
  | "globe"
  | "chevron-up"
  | "book"
  | "calendar"
  | "car"
  | "store"
  | "tags"
  | "upload"
  | "unlink"
  | "shopping-basket"
  | "truck"
  | "wrench"
  | "medicine"
  | "energy"
  | "megaphone"
  | "trash"
  | "user-add"
  | "user-remove"
  | "steering";

/** Small inline-SVG icon set for admin-v2 CTAs. The repo has no icon font installed (the
 * reference design's Hugeicons/Phosphor webfonts are prototype-only CDN assets), so these are
 * hand-drawn strokes matching the reference's visual weight instead of adding a new font dependency. */
@Component({
  selector: "app-admin-v2-icon",
  standalone: true,
  templateUrl: "./icon.component.html",
  styleUrl: "./icon.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  @Input({ required: true }) name!: AdminV2IconName;
  @Input() size = 16;

  get viewBox(): string {
    return this.name === "download" ? "0 0 24 24" : "0 0 16 16";
  }
}
